import React, { useRef, useState } from 'react';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { App, Button, Input, Popconfirm, Popover, Space } from 'antd';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../services/react-query/queryKeys';
import { deletePatient, getPatients } from '../../network/patients';
import { useNavigate } from 'react-router-dom';
import { FaCalendarCheck } from 'react-icons/fa';
import { SearchOutlined } from '@ant-design/icons';
import { colorPrimary } from '../../utils/utils';

const Patients = ({ t }) => {
  const client = useQueryClient();
  const [pageCount, setPageCount] = useState(1);
  // console.log(pageCount, 'pageCount');
  const [textValue, setTextValue] = useState('');
  const [searchText, setSearchText] = useState({
    value: '',
    key: '',
  });
  // console.log(searchText, 'searchText');
  const navigate = useNavigate();
  const { message } = App.useApp();
  const searchInput = useRef(null);
  const searchInputMobile = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText({ value: selectedKeys[0], key: dataIndex });
  };
  const handleReset = (clearFilters, confirm) => {
    confirm();
    setTextValue('');
    clearFilters();
    setSearchText({ value: '', key: '' });
  };
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.patients, searchText.key, searchText.value],
    queryFn: () => getPatients(searchText.key, searchText.value),
    keepPreviousData: true,
  });
  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (id) => deletePatient(id),
      onSuccess: (data) => {
        // console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(data?.message ? data?.message : 'Deleted successfully');
        // message.success('تم الحذف بنجاح');
        client.invalidateQueries({ queryKey: [queryKeys.patients] });
      },
      onError: () => {
        message.error('Something went wrong');
      },
    }
  );
  const columns = [
    {
      title: t.fileNumber,
      dataIndex: 'custom_file_number',
      key: 'custom_file_number',
      filterIcon: () => <SearchOutlined color={colorPrimary} />,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            ref={searchInputMobile}
            placeholder={t.fileNumber}
            value={textValue}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              setTextValue(e.target.value);
            }}
            onPressEnter={() =>
              handleSearch(selectedKeys, confirm, 'custom_file_number')
            }
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, 'custom_file_number')}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Search}
            </Button>
            <Button
              onClick={() => clearFilters && handleReset(clearFilters, confirm)}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Reset}
            </Button>
          </Space>
        </div>
      ),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTextValue('');
          setSearchText({ value: '', key: '' });
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
      render: (text, record) => {
        return (
          <span
            style={{ cursor: 'pointer' }}
            className="text-primary"
            onClick={() => {
              navigate(`/patients/${record.custom_file_number}`);
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: t.patientName,
      dataIndex: 'patient_name',
      key: 'patient_name',
      filterIcon: () => <SearchOutlined color={colorPrimary} />,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            ref={searchInputMobile}
            placeholder={t.patientName}
            value={textValue}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              setTextValue(e.target.value);
            }}
            onPressEnter={() =>
              handleSearch(selectedKeys, confirm, 'patient_name')
            }
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() =>
                handleSearch(selectedKeys, confirm, 'patient_name')
              }
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Search}
            </Button>
            <Button
              onClick={() => clearFilters && handleReset(clearFilters, confirm)}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Reset}
            </Button>
          </Space>
        </div>
      ),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTextValue('');
          setSearchText({ value: '', key: '' });
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    {
      title: t.identificationNumber,
      dataIndex: 'uid',
      key: 'uid',
      filterIcon: () => <SearchOutlined color={colorPrimary} />,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            ref={searchInput}
            placeholder={t.identificationNumber}
            value={textValue}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              setTextValue(e.target.value);
            }}
            // onChange={(e) => (
            //   setSearchText({ value: e.target.value, key: 'uid' }),
            //   setSelectedKeys(e.target.value ? [e.target.value] : [])
            // )}
            onPressEnter={() => handleSearch(selectedKeys, confirm, 'uid')}
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          />
          <Space>
            <Button
              type="primary"
              // onClick={() => confirm()}
              onClick={() => handleSearch(selectedKeys, confirm, 'uid')}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Search}
            </Button>
            <Button
              onClick={() => clearFilters && handleReset(clearFilters, confirm)}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Reset}
            </Button>
          </Space>
        </div>
      ),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTextValue('');
          setSearchText({ value: '', key: '' });
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    {
      title: t.mobile,
      dataIndex: 'mobile',
      key: 'mobile',
      render: (text) => (
        <a href={`tel:${text}`} className="text-ltr">
          {text}
        </a>
      ),
      filterIcon: () => <SearchOutlined color={colorPrimary} />,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            ref={searchInputMobile}
            placeholder={t.mobile}
            value={textValue}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              setTextValue(e.target.value);
            }}
            onPressEnter={() => handleSearch(selectedKeys, confirm, 'mobile')}
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, 'mobile')}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Search}
            </Button>
            <Button
              onClick={() => clearFilters && handleReset(clearFilters, confirm)}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Reset}
            </Button>
          </Space>
        </div>
      ),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTextValue('');
          setSearchText({ value: '', key: '' });
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    {
      title: t.age,
      dataIndex: 'age',
      key: 'age',
    },
    {
      title: t.gender,
      dataIndex: 'sex',
      key: 'sex',
    },
    {
      title: t.bloodGroup,
      dataIndex: 'blood_group',
      key: 'blood_group',
    },
    {
      title: t.email,
      dataIndex: 'email',
      key: 'email',
    },

    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => {
        // console.log('record:', record);
        return (
          <Space>
            <Popover
              placement="top"
              title={t.edit}
              onClick={() =>
                navigate(`/patients/${record?.custom_file_number}`)
              }
            >
              <Button
                size="small"
                type="primary"
                // onClick={() => navigate(`/patients/${record.uid}`)}
              >
                <MdModeEditOutline />
              </Button>
            </Popover>
            <Popconfirm
              title={t.DeletethePatient}
              description={t.Areyousuretodeletethispatient}
              onConfirm={() => handleRemove.mutate(record.custom_file_number)}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button size="small" type="primary" danger>
                <MdDelete />
              </Button>
            </Popconfirm>
            <Popover
              placement="top"
              title={t.addAnAppointment}
              onClick={() =>
                navigate(
                  `/appointments/patient/add/${record?.custom_file_number}`
                )
              }
            >
              <Button size="small" type="primary">
                <FaCalendarCheck />
              </Button>
            </Popover>
          </Space>
        );
      },
    },
  ];
  const dataTable =
    data?.data?.map((item, index) => ({
      key: index,
      custom_file_number: item?.custom_file_number,
      patient_name: item?.patient_name,
      age: item?.age,
      sex: item?.sex,
      blood_group: item?.blood_group,
      email: item?.email,
      uid: item?.uid,
      mobile: item?.mobile,
      action: item?.action,
    })) || [];
  const { current_page, total_count, total_pages } = data?.message || {};
  return (
    <div className="patients">
      <Heading title={t.Healthcare} subTitle={t.patient} path="/" />
      <DynamicTableAnt
        columns={columns}
        data={dataTable}
        loading={isLoading}
        setSearchText={setSearchText}
        titleBtn={t.addPatient}
        // Placeholder={t.searchPatient}
        searchInput={true}
        pathBtn="/patients/add"
        totalCount={total_count}
        totalPages={total_pages}
        setPageCount={setPageCount}
        pageCount={pageCount}
      />
    </div>
  );
};

export default Patients;
